import { render, staticRenderFns } from "./SubscriptionChoose.vue?vue&type=template&id=510b55bf&scoped=true"
import script from "./SubscriptionChoose.vue?vue&type=script&lang=js"
export * from "./SubscriptionChoose.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionChoose.vue?vue&type=style&index=0&id=510b55bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b55bf",
  null
  
)

export default component.exports